<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="stockLoading">
          <v-toolbar color="primary" dark>
            Stock Grid View
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information-variant</v-icon>
              </template>
              <p>
                ToolTip!
              </p>
            </v-tooltip>-->
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              prepend-icon="mdi-magnify"
              clearable
              v-on:input="onQuickFilterChanged()"
            ></v-text-field>
          </v-toolbar>
          <expandedToolbar
            :hasImageFilter="true"
            @hasImageFilterUpdated="updateFilter"
          />
          <v-card-text v-if="stock">
            <v-row>
              <v-col style="height: calc(100vh - 300px) !important" cols="12">
                <ag-grid-vue
                  :style="{ width, height }"
                  class="ag-theme-alpine"
                  :defaultColDef="defaultColDef"
                  :columnDefs="columnDefs"
                  :rowData="rowData"
                  :animateRows="true"
                  :rowBuffer="1"
                  :paginationAutoPageSize="true"
                  :pagination="true"
                  :isExternalFilterPresent="isExternalFilterPresent"
                  :doesExternalFilterPass="doesExternalFilterPass"
                  rowSelection="multiple"
                  @grid-ready="onGridReady"
                  @cellDoubleClicked="onCellDoubleClick"
                ></ag-grid-vue>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="aGGridActionMenu" persistent max-width="300px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Action Menu
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="updateAGGridActionMenu()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-list v-if="selectedRowData" dense>
                  <!-- <v-list-item :to="'/dashboard'">
                    <v-list-item-action>
                      <v-icon>mdi-account-box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Event Profile</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>-->
                  <v-list-item @click="viewStockDetails()">
                    <v-list-item-action>
                      <v-icon>mdi-information-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>View Details</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="uploadImageDialogOpen()">
                    <v-list-item-action>
                      <v-icon>mdi-image-plus</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Upload Image</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewDetailsDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Item #{{ selectedRowData.id }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="viewDetailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-img
          v-if="selectedRowData.hasImage == 1"
          height="300px"
          width="300px"
          style="margin: auto; border: solid grey 2px"
          class="mt-2"
          :src="`https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/StockImages/${selectedRowData.Oid}.${selectedRowData.imageExt}`"
        ></v-img>
        <v-img
          v-else
          contain
          height="300px"
          src="
            https://via.placeholder.com/300
          "
        >
        </v-img>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" style="text-align: center">
                <v-btn
                  class="btn"
                  color="primary"
                  @click="uploadImageDialogOpen()"
                >
                  Change Image
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Brand</p>
                <p class="mb-0">{{ selectedRowData.Brand }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Code</p>
                <p class="mb-0">{{ selectedRowData.Code }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Company On Hand</p>
                <p class="mb-0">{{ selectedRowData.CompanyOnHand }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Home Branch On Hand</p>
                <p class="mb-0">{{ selectedRowData.HomeBranchOnHand }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Description</p>
                <p class="mb-0">{{ selectedRowData.Description }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Selling Price</p>
                <p class="mb-0">{{ selectedRowData.SellingPrice }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Oid</p>
                <p class="mb-0">{{ selectedRowData.Oid }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">GUID</p>
                <p class="mb-0">{{ selectedRowData.Guid }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Manufacture marking</p>
                <p class="mb-0">{{ selectedRowData.ManufactureMarking }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Stock Category Code</p>
                <p class="mb-0">{{ selectedRowData.StockCategoryCode }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">
                  Stock Category Description
                </p>
                <p class="mb-0">
                  {{ selectedRowData.StockCategoryDescription }}
                </p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Stock Group Code</p>
                <p class="mb-0">{{ selectedRowData.StockGroupCode }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Unit Description</p>
                <p class="mb-0">{{ selectedRowData.UnitDescription }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadImageDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Upload an Image for #{{ selectedRowData.id }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="uploadImageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <croppa
                  v-model="image"
                  :show-loading="true"
                  :width="300"
                  :height="300"
                  :quality="2"
                  canvas-color="#FFF"
                  placeholder-color="#000000"
                  placeholder="Choose profile image"
                  style="width: 300px"
                  initial-size="contain"
                />
                <!-- <v-file-input
                  :rules="imageUploadRules"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="Choose an Image"
                  prepend-icon="mdi-camera"
                  label="Image"
                  v-model="image"
                  @change="updatePreviewImage"
                ></v-file-input> -->
              </v-col>
              <!-- <v-col v-if="previewUrl != null" cols="12">

                <v-img :src="previewUrl"></v-img>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            color="success"
            :loading="imageUploadLoading"
            @click="uploadImage()"
            >Upload Image</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import agGridActionButton from "@/components/agGridActionButton";
  import agGridHasImageRender from "@/components/agGridHasImageRender";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import { AgGridVue } from "ag-grid-vue";
  import moment from "moment";

  export default {
    components: {
      AppBar,
      AgGridVue,
      agGridActionButton,
      expandedToolbar,
      agGridHasImageRender,
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "aGGridActionMenu",
        "selectedRowData",
        "stock",
        "stockLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      // AG-Grid
      columnDefs: null,
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "100%",
      search: "",
      searchDebounce: null,
      viewDetailsDialog: false,
      // Image Upload
      uploadImageDialog: false,
      imageUploadRules: [
        (value) =>
          !value ||
          value.size < 40000000 ||
          "Avatar size should be less than 40 MB!",
      ],
      image: null,
      previewUrl: null,
      imageUploadLoading: false,
      imageFilterValue: "All",
    }),
    mounted() {
      // this.columnDefs = [

      //   {
      //     headerName: "ID",
      //     field: "id",
      //   },
      // ];
      this.columnDefs = [
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "agGridActionButton",
        },
        {
          headerName: "Image",
          field: "hasImage",
          cellRendererFramework: "agGridHasImageRender",
        },
        {
          headerName: "Code",
          field: "Code",
        },
        {
          headerName: "Description",
          field: "Description",
        },
        {
          headerName: "Company Stk",
          field: "CompanyOnHand",
        },
        {
          headerName: "Manufacture Marking",
          field: "ManufactureMarking",
        },
        {
          headerName: "Category Description",
          field: "StockCategoryDescription",
        },
        {
          headerName: "Unit Description",
          field: "UnitDescription",
        },
        {
          headerName: "Image Ext",
          field: "imageExt",
          hide: true,
        },
      ];
      this.$store.dispatch("loadStock", false).then(() => {
        this.setGridData();
      });
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }
    },
    methods: {
      setGridData() {
        const rowData = this.stock;
        this.gridApi.setRowData(rowData);
        setTimeout(() => {
          var allColumnIds = [];
          this.columnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
          });
          this.columnApi.autoSizeColumns(allColumnIds, false);
        }, 50);
      },
      onQuickFilterChanged() {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
          this.gridApi.setQuickFilter(this.search);
        }, 500);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        if (this.stock.length != 0) {
          setTimeout(() => {
            this.setGridData();
          }, 200);
        }
      },
      autoSizeColumnsAGGRID() {
        // this.gridApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("setSelectedRowData", cell.data);
        this.viewStockDetails();
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("setAGGridActionMenuState", {});
      },
      viewStockDetails() {
        this.viewDetailsDialog = true;
      },
      uploadImageDialogOpen() {
        this.uploadImageDialog = true;
      },
      uploadImage() {
        this.imageUploadLoading = true;
        this.previewUrl = this.image.generateDataUrl();
        const payload = {
          id: this.selectedRowData.id,
          Oid: this.selectedRowData.Oid,
          data: this.previewUrl,
        };
        this.$store.dispatch("stockUploadImage", payload).then((result) => {
          if (result.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: "Image has been Uploaded",
              type: "success",
              confirmButtonText: "Ok",
            });
            let rowNode = this.gridApi.getSelectedNodes();
            rowNode[0].setDataValue("hasImage", 1);
            const fileData = this.previewUrl;
            let ext = fileData.match(/.*image\/(.*);/);
            rowNode[0].setDataValue("imageExt", ext[1]);
          } else {
            this.$swal({
              title: "Error",
              text: "Please try again Later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
          this.imageUploadLoading = false;
          this.uploadImageDialog = false;
        });
      },
      updatePreviewImage() {
        if (this.image != undefined) {
          var reader = new FileReader();
          reader.readAsDataURL(this.image);
          reader.onload = () => {
            this.previewUrl = reader.result;
          };
        } else {
          this.previewUrl = null;
        }
      },
      isExternalFilterPresent() {
        return this.imageFilterValue !== "All";
      },
      doesExternalFilterPass(node) {
        switch (this.imageFilterValue) {
          case 1:
            return node.data.hasImage == 1;
          case 0:
            return node.data.hasImage == 0;
          default:
            return true;
        }
      },
      updateFilter(filter) {
        let val = 0;
        switch (filter) {
          case "All":
            val = "All";
            break;
          case "Has Image":
            val = 1;
            break;
          case "No Image":
            val = 0;
            break;
          default:
            break;
        }
        this.imageFilterValue = val;
        this.gridApi.onFilterChanged();
      },
    },
  };
  window.hasImageFormatter = function hasImageFormatter(params) {
    if (params.data.hasImage == 1) {
      return true;
    } else {
      return false;
    }
  };
</script>

<style>
  .croppa-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .croppa-container canvas {
    border: 1px solid;
  }
</style>
